@if (!isHeader) {
  <th scope="col" class="border-bold-left" translate>{{rowHeader}}</th>
  <td class="text-align-right border-bold-left">
    @if (!(rowHeader?.includes('.kendallTauB') || rowHeader?.includes('.pearson'))) {
      <span> {{rowData?.analyseNurGrundlohn  | numberFormat:crtLocale:2}}</span>
    }
    @if ((rowHeader?.includes('.kendallTauB') || rowHeader?.includes('.pearson'))) {
      <span>{{rowData?.analyseNurGrundlohn  | numberFormat:crtLocale:4}}</span>
    }
  </td>
  <td class="text-align-right border-bold-left">
    @if (!(rowHeader?.includes('.kendallTauB') || rowHeader?.includes('.pearson'))) {
      <span>{{rowData?.analyseFixeGewichtung  | numberFormat:crtLocale:2}}</span>
    }
    @if ((rowHeader?.includes('.kendallTauB') || rowHeader?.includes('.pearson'))) {
      <span>{{rowData?.analyseFixeGewichtung  | numberFormat:crtLocale:4}}</span>
    }
  </td>
  <td class="text-align-right border-bold-left border-bold-right" [ngClass]="{'shaded': !isHeader}">
    @if (!(rowHeader?.includes('.kendallTauB') || rowHeader?.includes('.pearson'))) {
      <span>{{rowData?.standardAnalyseModell  | numberFormat:crtLocale:2}}</span>
    }
    @if ((rowHeader?.includes('.kendallTauB') || rowHeader?.includes('.pearson'))) {
      <span>{{rowData?.standardAnalyseModell  | numberFormat:crtLocale:4}}</span>
    }
  </td>
} @else {
  <th scope="col" class="border-bold-left header centered bold" translate>{{rowHeader}}</th>
  <td class="text-align-right border-bold-left header"></td>
  <td class="text-align-right border-bold-left header"></td>
  <td class="text-align-right border-bold-left border-bold-right header "></td>
}


